import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContactUsModel } from '../components/global/contact-us';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { ApplicationRoles } from '../components/users/user-roles';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  apiUrl = environment.apiUrl
  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private httpclient: HttpClient, private authservice: AuthService, private translationService: TranslationService) { }

  createEnquiry(contactusmodel: ContactUsModel): Observable<any> {
    let token = this.authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.httpclient.post<any>(this.apiUrl + "contactUs/createEnquiry", contactusmodel, { headers: headers });
  }

  getContactUsSubHeading(translation: any, isLoggedIn = true): string {
    if (!isLoggedIn) {
      return translation['contactUsBBSelfGuidedParticipant'] ?? '';
    }

    if (!this.authservice.getUserLoginData().isParticipant) {
      return translation['contactUsAdmin'] ?? '';
    }

    let content = ""
    let activeRole = this.authservice.getAccessControl().participantLastActiveRole

    switch (activeRole) {
      case ApplicationRoles.BB_CoachedParticipant:
        content = translation['contactUsBBCoachedParticipant']
        break;
      case ApplicationRoles.BB_SelfGuidedParticipant:
        content = translation['contactUsBBSelfGuidedParticipant']
        break;
      default:
        content = ""
    }

    return content;
  }
}
